import { render } from "./NfBoard.vue?vue&type=template&id=e63b2884"
import script from "./NfBoard.vue?vue&type=script&lang=js"
export * from "./NfBoard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__